class Cache {
    constructor() {
        this._kv = {};
    }

    unmount = () => {
    }

    store = (category, key, value, ttl=300000) => {
        const idx = category + '/' + key;
        this._kv[idx] = {
            timestamp: Date.now(),
            ttl: ttl,
            data: value
        };
    }

    query = (category, key) => {
        const idx = category + '/' + key;

        const value = this._kv[idx];

        if (value) {
            const now = Date.now();

            if (now <= (value.timestamp + value.ttl)) {
                return value.data;
            } else {
                delete this._kv[idx];

            }
        }

        return null;
    }

    remove = (category, key) => {
        const idx = category + '/' + key;
        delete this._kv[idx];
    }
}

const GlobalCache = new Cache();
export default GlobalCache;
